module.exports = __webpack_public_path__ + "static/media/udemy-ztm.ce0eca77.jpg";